import Player from 'griffith'
import React, {useState} from "react";
import {Avatar, Button, List} from "antd";
import {getFrontEndAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies";

export function IsDownLoad(props){


    const role = "role"
    const isDownLoad=()=>{
        if(props.isDownLoad === cookie.load(role) || props.isDownLoad === "all"){
            return <a href={"http://"+getFrontEndAddress()+props.relativeAddress} download={props.resourcesName}>{props.resourcesName}</a>
        }else {
            return <p>{props.resourcesName}</p>
        }
    }

    return(
        isDownLoad()
    )
}


